import * as CONST from 'Reducers/Inventory/const'
import { hashObject } from 'Utils/Strings'

const initState = {
  inventoryTypes: [],
  inventoryItems: {},
  search: {},
}

export function inventory(state = initState, action) {
  switch (action.type) {
    case CONST.LOAD_INVENTORY: {
      let searchHash = hashObject(action.payload.filters)
      return {
        ...state,
        search: {
          ...state.search,
          [searchHash]: {
            ...state.search[searchHash],
            loading: true,
          },
        },
      }
    }

    case CONST.LOAD_INVENTORY_SUCCESS: {
      var inventoryItems = {},
        movements = {}
      action.result.data.inventoryItems.edges.forEach(edge => {
        const node = edge.node
        inventoryItems[node.id] = {
          id: node.id,
          typeId: node.inventoryType.id,
          clientId: node.client.id,
          description: node.description,
          campaignId: node.campaignId,
          tag: node.tag,
        }
        var inventoryItemMovements = []
        node.movementsV2.nodes.forEach(m =>
          inventoryItemMovements.push({
            comments: m.comments,
            id: m.id,
            movementTypeId: m.movementType.id,
            quantity: m.quantity,
            relatedCityId: m.relatedCity.id,
            relatedUserId: m.relatedUser ? m.relatedUser.id : null,
            relatedMissionId: m.relatedMission ? m.relatedMission.id : null,
            dateTime: m.dateTime,
            inventoryId: node.id,
          }),
        )
        // TODO This isn't totally normalised
        movements[node.id] = inventoryItemMovements
      })

      let searchHash = hashObject(action.payload.filters)
      const searchIds = action.payload.resetSearch
        ? [...Object.keys(inventoryItems)]
        : [
            // TODO Only add this id if the cursor matches up
            ...(state.search[searchHash].ids || []),
            ...Object.keys(inventoryItems),
          ]

      return {
        ...state,
        inventoryItems: {
          ...state.inventoryItems,
          ...inventoryItems,
        },
        movements: {
          ...state.movements,
          ...movements,
        },
        search: {
          ...state.search,
          [searchHash]: {
            loading: false,
            pageInfo: action.result.data.inventoryItems.pageInfo,
            totalCount: action.result.data.inventoryItems.totalCount,
            ids: searchIds,
          },
        },
      }
    }

    case CONST.MOVE_INVENTORY:
      var payloadMovement = action.payload.inventoryMovement
      var movement = {
        comments: payloadMovement.comments,
        id: payloadMovement.id,
        movementTypeId: payloadMovement.movement,
        quantity: payloadMovement.quantity,
        relatedCityId: String(payloadMovement.cityId),
        relatedUserId: payloadMovement.ambassadorId,
        relatedMissionId: null,
        dateTime: payloadMovement.dateTime,
        inventoryId: payloadMovement.inventoryId,
      }
      const inventoryMovements = [
        ...state.movements[movement.inventoryId],
        ...movement,
      ]

      return {
        ...state,
        movements: {
          ...state.movements,
          [movement.inventoryId]: inventoryMovements,
        },
      }

    case CONST.GET_INVENTORY_TYPES_SUCCESS: {
      return {
        ...state,
        inventoryTypes: [...action.payload.inventoryTypes],
      }
    }
    case CONST.ADD_INVENTORY_ITEM_SUCCESS: {
      const item = action.result.data.addInventoryItem
      const existingMovements = state.movements[item.id]
        ? state.movements[item.id]
        : []
      const movements = [
        ...existingMovements,
        ...item.movements.nodes.map(movement => ({
          comments: movement.comments,
          id: movement.id,
          movementTypeId: movement.movementType
            ? movement.movementType.id
            : null,
          quantity: movement.quantity,
          relatedCityId: movement.relatedCity ? movement.relatedCity.id : null,
          relatedUserId: movement.relatedUser ? movement.relatedUser.id : null,
          relatedMissionId: movement.relatedMission
            ? movement.relatedMission.id
            : null,
          dateTime: movement.dateTime,
          inventoryId: item.id,
        })),
      ]

      return {
        ...state,
        inventoryItems: {
          ...state.inventoryItems,
          [item.id]: {
            id: item.id,
            typeId: item.inventoryType.id,
            clientId: item.client.id,
            description: item.description,
            campaignId: item.campaignId,
          },
        },
        movements: {
          ...state.movements,
          [item.id]: movements,
        },
      }
    }
    case CONST.GET_INVENTORY_ITEM_SUCCESS: {
      var item = action.result.data.inventoryItem
      let movements = item.movements.nodes.map(m => ({
        comments: m.comments,
        id: m.id,
        movementTypeId: m.movementType ? m.movementType.id : null,
        quantity: m.quantity,
        relatedCityId: m.relatedCity ? m.relatedCity.id : null,
        relatedUserId: m.relatedUser ? m.relatedUser.id : null,
        relatedMissionId: m.relatedMission ? m.relatedMission.id : null,
        dateTime: m.dateTime,
        inventoryId: item.id,
      }))
      return {
        ...state,
        inventoryItems: {
          ...state.inventoryItems,
          [action.payload.id]: {
            id: item.id,
            typeId: item.inventoryType.id,
            clientId: item.client.id,
            description: item.description,
            campaignId: item.campaignId,
            tag: item.tag,
          },
        },
        movements: {
          ...state.movements,
          [action.payload.id]: movements,
        },
      }
    }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/Inventory/reducer.js